import AppConfig from "../../config";
import httpClient from "../../utils/http-client";
import IdNameModel from "../../models/common/IdNameModel";
import BaseResponse from "../../models/common/BaseResponse";
import BaseResponseList from "../../models/common/BaseResponseList";
import PagedListModel from "../../models/common/PagedListModel";
import DomainSearchInputModel from "../../models/company/domain/request/DomainSearchInputModel";
import DomainModel from "../../models/company/domain/response/DomainModel";
import DomainRequestModel from "../../models/company/domain/request/DomainRequestModel";

class DomainService {
    async fillDomains(companyId: string) {
        let res: BaseResponseList<IdNameModel[]> = await httpClient.get<BaseResponseList<IdNameModel[]>>(AppConfig.company.domain.fillDomains  + "/" + companyId);
        return res;
    };

    async getDomains(inputParms: DomainSearchInputModel) {
        let res: PagedListModel<DomainModel> = await httpClient.post<PagedListModel<DomainModel>>(AppConfig.company.domain.getDomains, inputParms);
        return res;
    };

    async getDomainById(domainId: number) {
        let res: BaseResponse<DomainModel> = await httpClient.get<BaseResponse<DomainModel>>(AppConfig.company.domain.getDomainById  + "/" + domainId);
        return res;
    };

    async saveDomain(domain: DomainRequestModel) {
        let res: BaseResponse<boolean> = await httpClient.post<BaseResponse<boolean>>(AppConfig.company.domain.saveDomain, domain);
        return res;
    };
}
const domainService = new DomainService();
export default domainService;